// Add N business days (Monday–Friday, no holiday calendar) to an instant, keeping the same US
// Eastern time of day — the frontend twin of the backend's shared-lib helper/add-business-days, so
// the date shown to the client matches the one the backend enforces (FCRA pre-adverse waiting
// period, 5 business days — client agreement §4).

const DAY_MS = 24 * 60 * 60 * 1000
const TIME_ZONE = "America/New_York"

const partsFormatter = new Intl.DateTimeFormat("en-US", {
    timeZone: TIME_ZONE,
    hourCycle: "h23",
    weekday: "short",
    year: "numeric",
    month: "numeric",
    day: "numeric",
    hour: "numeric",
    minute: "numeric",
    second: "numeric",
})

const zonedParts = (ms) => Object.fromEntries(partsFormatter.formatToParts(new Date(ms)).map((p) => [p.type, p.value]))

const offsetAt = (ms) => {
    const p = zonedParts(ms)
    const asUtc = Date.UTC(Number(p.year), Number(p.month) - 1, Number(p.day), Number(p.hour), Number(p.minute), Number(p.second))
    return asUtc - Math.floor(ms / 1000) * 1000
}

const isWeekend = (ms) => {
    const weekday = zonedParts(ms).weekday
    return weekday === "Sat" || weekday === "Sun"
}

const addBusinessDays = (from, businessDays) => {
    const start = new Date(from).getTime()

    let calendarDays = 0
    let counted = 0
    while (counted < businessDays) {
        calendarDays += 1
        if (!isWeekend(start + calendarDays * DAY_MS)) {
            counted += 1
        }
    }

    const naive = start + calendarDays * DAY_MS
    return new Date(naive + (offsetAt(start) - offsetAt(naive)))
}

export default addBusinessDays
